import React, { useState, useEffect, FC } from 'react';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import * as ST from './styled';

type TField = {
    value: string,
    isValid: boolean,
    clearInput: () => void,
}

type TMessage = {
    ok: boolean,
    text: string,
}

export interface ISubmitParam {
    fio: string,
    phone: string,
}

interface IProps {
    isLoading?: boolean,
    isVertical?: boolean,
    withAgreeLink?: boolean,
    message?: TMessage,
    cityDomain?: string,
    btnText?: string | React.ReactNode,
    submitRequest: (param: ISubmitParam) => void,
    formFilledHandler?: () => void,
}

/**
 *
 * @param {boolean} isLoading - отображение спинера загрузки
 * @param {boolean} isVertical - вертикальное расположение полей на всех размерах экрана
 * @param {object} message - сообщение, о результате, внизу формы
 * @param {function} submitRequest - колбэк при клике на кнопку
 * @param btnText
 * @param withAgreeLink
 */
export const RequestForm:FC<IProps> = ({
    isLoading,
    isVertical,
    message,
    cityDomain,
    submitRequest,
    btnText = 'Отправить заявку',
    withAgreeLink = true,
    formFilledHandler,
}: IProps) => {
    const [phone, setPhone] = useState<TField>();
    const [name, setName] = useState<TField>();
    const [isValidInputs, setIsValidInputs] = useState<boolean>(false);
    const [startInput, setStartInput] = useState<boolean>(false);

    useEffect(() => {
        setIsValidInputs(!!(phone?.isValid && name?.isValid));
        if (phone?.isValid && name?.isValid && formFilledHandler) {
            formFilledHandler();
        }
        setStartInput(true);
    }, [phone, name, formFilledHandler]);

    useEffect(()=>{
        dataLayerPush({
            event: 'UAevent',
            category: 'application_form',
            action: 'started',
            label: `body | ${cityDomain} | ${window.location.pathname}`,
        });
    }, [startInput]);

    const submitHandler = () => {
        if (isValidInputs) {
            submitRequest({
                fio: name?.value || '',
                phone: phone?.value || '',
            });
            phone?.clearInput();
            name?.clearInput();
            dataLayerPush({
                event: 'UAevent',
                category: 'application_form',
                action: 'finished',
                label: `body | ${cityDomain} | ${window.location.pathname}`,
            });
        }
    };

    return (
        <ST.RequestFormWrapper>
            <ST.Inputs isVertical={isVertical}>
                <ST.Name
                    name='name'
                    onChange={setName}
                    placeholder='Ваше имя'
                    errorMessage='Ожидаются только буквы и дефисы'
                    isVertical={isVertical}
                    data-test='field-name'
                />
                <ST.Phone
                    name='phone'
                    onChange={setPhone}
                    placeholder='Номер телефона'
                    errorMessage='Телефон в формате +7 (999) 999-99-99'
                    data-test='field-phone'
                />
            </ST.Inputs>
            <ST.ButtonBlock isVertical={isVertical}>
                <ST.Button
                    onClick={submitHandler}
                    disabled={!isValidInputs || isLoading}
                    isVertical={isVertical}
                    data-test='submit-btn'
                >{btnText}</ST.Button>
                {withAgreeLink && (
                    <ST.Agree>
                        Нажимая на кнопку, вы соглашаетесь на обработку
                        <ST.AgreeLink
                            href='https://dom.ru/policy.pdf'
                            data-test='agreement'
                        >
                            персональных данных
                        </ST.AgreeLink>
                    </ST.Agree>
                )}
            </ST.ButtonBlock>
            {message
                ? <ST.Message ok={message?.ok}>{message?.text}</ST.Message>
                : null
            }
            <ST.StyledThrobber waitStatus={!isLoading}/>
        </ST.RequestFormWrapper>
    );
};
